module.exports = __webpack_public_path__ + "img/中国荔枝产业大会会址.82119d82.png";